// extracted by mini-css-extract-plugin
export default {"report-type-tag":"ReportTypeTag_report-type-tag__IP0B1","standard":"ReportTypeTag_standard__wrbWQ","flagship":"ReportTypeTag_flagship__mz6Ri","free":"ReportTypeTag_free__6sqzz"};